import React, { useEffect, useState } from 'react'
import injectSheet from 'react-jss'
import { apiClient } from 'pobble-components/dist/api'
import { useParams } from 'react-router-dom'
import { ParentPrompt } from './parent-prompt'
import { PARENT_PAGE_BG } from './parent-theme'

const PARENT_WRITING_INCLUDE =
  'parent_writing.presentation,parent_writing.presentation.image,parent_writing.presentation.names,parent_writing.presentation.details,parent_writing.presentation.slides,parent_writing.presentation.slide.type,parent_writing.presentation.slide.details,parent_writing.presentation.audio,parent_writing.presentation.year_groups,parent_writing.presentation.category,parent_writing.presentation.status,parent_writing.presentation.p365,parent_writing.presentation.account'

export const ParentWriting = injectSheet({
  info: {
    textAlign: 'center',
    color: 'var(--gray--)',
    font: 'var(--body)',
    padding: '48px 20px',
    minHeight: 'calc(100vh - 80px)',
    background: PARENT_PAGE_BG,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
})(({ classes }) => {
  const { id } = useParams()
  const [presentationId, setPresentationId] = useState(null)
  const [parentWritingId, setParentWritingId] = useState(null)
  const [hasError, setHasError] = useState(false)

  useEffect(
    () => {
      setPresentationId(null)
      setParentWritingId(null)
      setHasError(false)

      apiClient
        .get(`/v3/parent_writings/${id}`, {
          params: {
            include: PARENT_WRITING_INCLUDE
          }
        })
        .then(res => {
          const parentWriting = res.data.parent_writing
          const writingId = parentWriting && parentWriting.id
          const linkedPresentationId =
            parentWriting &&
            parentWriting.presentation &&
            parentWriting.presentation.id

          if (writingId && linkedPresentationId) {
            setParentWritingId(writingId)
            setPresentationId(linkedPresentationId)
          } else {
            setHasError(true)
          }
        })
        .catch(() => {
          setHasError(true)
        })
    },
    [id]
  )

  if (!presentationId && !hasError) {
    return <div className={classes.info}>Getting your writing ready…</div>
  }

  if (hasError) {
    return (
      <div className={classes.info}>
        We couldn&apos;t open this writing. Please try again from your saved
        list.
      </div>
    )
  }

  return (
    <ParentPrompt
      presentationId={presentationId}
      parentWritingId={parentWritingId}
    />
  )
})
